var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs, _polygon, _polygon2, _polygon3, _defs2, _polygon4, _rect, _rect2, _rect3, _rect4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSticky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 513 232.4",
    style: {
      enableBackground: "new 0 0 513 232.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D6E71;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#90C8E1;}\n\t.st4{clip-path:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-normal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.1,122.9c0,7.9-6.4,14.2-14.2,14.2c-7.9,0-14.2-6.4-14.2-14.2s6.4-14.2,14.2-14.2S197.1,115.1,197.1,122.9 L197.1,122.9 M199.7,122.9c0-9.3-7.6-16.9-16.9-16.9c-9.3,0-16.9,7.6-16.9,16.9c0,9.3,7.6,16.9,16.9,16.9c0,0,0,0,0,0 C192.2,139.8,199.7,132.3,199.7,122.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,122.9L295.1,122.9L295.1,122.9c0,7.9-6.4,14.2-14.3,14.2s-14.2-6.4-14.2-14.3c0-7.8,6.4-14.2,14.2-14.2 C288.7,108.7,295.1,115,295.1,122.9C295.1,122.9,295.1,122.9,295.1,122.9 M297.8,139.8v-16.9c0-9.3-7.5-16.9-16.9-16.9 c-9.3,0-16.9,7.5-16.9,16.9s7.5,16.9,16.9,16.9c5.8,0,11.2-2.9,14.3-7.8v7.8H297.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.1,121.7h-28.3c0.8-7.8,7.7-13.6,15.5-12.8C387.1,109.5,392.4,114.9,393.1,121.7 M395.8,123 c0-9.3-7.6-16.9-16.9-16.9c-9.3,0-16.9,7.6-16.9,16.9s7.6,16.9,16.9,16.9c0,0,0,0,0,0v-2.6c-7.3,0-13.5-5.6-14.2-12.9h31 C395.8,123.9,395.8,123.4,395.8,123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.9,108.7v-2.7c-9.3,0-16.9,7.5-16.9,16.8v17h2.7v-17l0,0C413.8,115,420.1,108.7,427.9,108.7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.1,122.9L344.1,122.9L344.1,122.9c0,7.9-6.4,14.2-14.3,14.2s-14.2-6.4-14.2-14.3c0-7.8,6.4-14.2,14.2-14.2 C337.8,108.7,344.1,115,344.1,122.9C344.1,122.9,344.1,122.9,344.1,122.9 M346.8,122.9c0-9.4-7.5-17-16.9-17c-9.4,0-17,7.5-17,16.9 s7.5,17,16.9,17c5.8,0,11.2-2.9,14.3-7.8v1.7l0,0c-0.1,7.8-6.4,14.1-14.2,14.1v2.6c9.3,0,16.8-7.5,16.9-16.8L346.8,122.9 L346.8,122.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215,108.8v14.1c0,9.3,7.6,16.9,16.9,16.9c5.8,0,11.1-2.9,14.2-7.8v1.7l0,0c-0.1,7.8-6.4,14.1-14.2,14.1v2.6 c9.3,0,16.8-7.5,16.9-16.8v-10.7c0,0,0-0.1,0-0.1v-14.1h-2.6v14.1l0,0v0.2c0,7.9-6.5,14.2-14.3,14.1s-14.2-6.5-14.1-14.3l0,0v-14.1 H215z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "54.8,69 69.2,106.7 149.1,143.2 97.2,33.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -49.3837,
    y1: 90.804,
    x2: -48.3837,
    y2: 90.804,
    gradientTransform: "matrix(-29.3796 -125.2607 125.2607 -29.3796 -12701.7188 -3338.2957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90C8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#90C8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#86BDD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#6DA1BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#477796"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "30.4,39.3 144.1,12.7 173.4,137.5 59.7,164.2  "
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "95.7,32.1 40,32.1 0.6,111.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "208.8,28.6 168.7,0.5 164.9,19 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_4_",
    points: "166.9,0 127.7,9.1 111.3,58.6 141.7,123  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -46.6009,
    y1: 91.1997,
    x2: -45.6009,
    y2: 91.1997,
    gradientTransform: "matrix(-12.9543 129.7851 129.7851 12.9543 -12292.3271 4841.7915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90C8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#90C8E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#86BDD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#6DA1BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#477796"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "99.1,121.8 111.8,-5.5 179,1.2 166.3,128.5  "
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 212.5,
    y: 194.8,
    className: "st0",
    width: 1.9,
    height: 29.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 194.8,
    className: "st0",
    width: 1.9,
    height: 29.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 208.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -105.5785 167.9441)",
    className: "st3",
    width: 6.6,
    height: 6.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 365.6,
    y: 208.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -41.4285 322.8148)",
    className: "st3",
    width: 6.6,
    height: 6.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.8,212.5c0.2,5.7-4.3,10.4-10,10.6c-5.7,0.2-10.4-4.3-10.6-10c0-0.2,0-0.4,0-0.6l0,0 c0.2-5.7,4.9-10.2,10.6-10C284.3,202.7,288.6,207,288.8,212.5 M290.7,212.5c0-6.7-5.5-12.2-12.2-12.2c-4.2,0-8.1,2.1-10.3,5.7v-11 h-1.9v17.5l0,0c-0.2,6.7,5.1,12.4,11.9,12.6c6.7,0.2,12.4-5.1,12.6-11.9C290.7,212.9,290.7,212.7,290.7,212.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197,212.5L197,212.5L197,212.5c0,5.7-4.6,10.3-10.3,10.3s-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3 C192.4,202.1,197,206.8,197,212.5C197,212.5,197,212.5,197,212.5 M198.9,220.3v-7.8c0-6.8-5.5-12.2-12.2-12.2 c-6.8,0-12.2,5.5-12.2,12.2c0,6.8,5.5,12.2,12.2,12.2c4.2,0,8.1-2.1,10.3-5.7v1.2l0,0c0,5.6-4.6,10.2-10.3,10.2v1.9 C193.4,232.4,198.9,227,198.9,220.3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453,212.5c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3l0,0 C448.3,202.2,453,206.8,453,212.5 M454.9,212.5c0-6.7-5.4-12.2-12.2-12.3c-6.7,0-12.2,5.4-12.3,12.2s5.4,12.2,12.2,12.3c0,0,0,0,0,0 C449.4,224.6,454.9,219.2,454.9,212.5L454.9,212.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513,200.2h-10.3v-5.3h-1.9v17.6c0.1,6.7,5.5,12.1,12.2,12.1v-1.9c-5.6,0-10.2-4.6-10.3-10.2v-10.3H513V200.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,212.5h1.9c0-6.7-5.5-12.2-12.2-12.2c-4.2,0-8.1,2.1-10.3,5.7v-11h-1.9v17.5l0,0v12.2h1.9v-12.2l0,0v-0.1 c0-5.7,4.7-10.3,10.4-10.2C410.3,202.1,414.9,206.8,414.8,212.5L414.8,212.5z M416.8,212.5h-1.9v12.2h1.9V212.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,212.3c0,5.7-4.6,10.3-10.3,10.3S40,218,40,212.3c0-5.7,4.6-10.3,10.3-10.3S60.6,206.6,60.6,212.3 L60.6,212.3 M62.6,212.3c0-6.7-5.5-12.2-12.2-12.2c-6.7,0-12.2,5.5-12.2,12.2s5.5,12.2,12.2,12.2c0,0,0,0,0,0 C57.1,224.5,62.5,219,62.6,212.3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.6,202v-1.9c-6.7,0-12.2,5.4-12.2,12.1v12.3h1.9v-12.3C116.3,206.5,120.9,202,126.6,202"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.2,212.3h1.9v-12.2h-1.9V212.3z M100.7,224.5v-24.4h-1.9v12.2l0,0v0.1c-0.2,5.7-5,10.1-10.7,9.9 c-5.4-0.2-9.8-4.6-9.9-10h-1.9c0,6.7,5.5,12.2,12.2,12.2c4.2,0,8.1-2.1,10.3-5.7v1.2l0,0v4.4L100.7,224.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,212.3h1.9v-17.3H0V212.3z M24.5,212.3L24.5,212.3v-17.3h-1.9v17.3l0,0v0.1c-0.2,5.7-5,10.1-10.7,9.9 c-5.4-0.2-9.8-4.6-9.9-10H0c0,6.7,5.5,12.2,12.2,12.2c4.2,0,8.1-2.1,10.3-5.7v1.2l0,0c-0.1,5.6-4.7,10.2-10.3,10.2v1.9 c6.7,0,12.2-5.4,12.2-12.1L24.5,212.3C24.4,212.4,24.4,212.3,24.5,212.3L24.5,212.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.6,212.3c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3c0-5.7,4.6-10.3,10.3-10.3l0,0 C246,202,250.6,206.6,250.6,212.3C250.6,212.3,250.6,212.3,250.6,212.3 M252.5,212.3c0-6.7-5.5-12.2-12.2-12.2 c-6.7,0-12.2,5.5-12.2,12.2s5.5,12.2,12.2,12.2c0,0,0,0,0,0C247,224.6,252.5,219.1,252.5,212.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.8,212.3L326.8,212.3L326.8,212.3c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3 c0-5.7,4.6-10.3,10.3-10.3C322.2,202,326.8,206.6,326.8,212.3C326.8,212.3,326.8,212.3,326.8,212.3 M328.7,224.6v-12.2 c0-6.8-5.4-12.3-12.2-12.3c-6.8,0-12.3,5.4-12.3,12.2s5.4,12.3,12.2,12.3c4.2,0,8.1-2.1,10.4-5.7v5.7L328.7,224.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.7,205.1c-4.1-5.4-11.8-6.6-17.2-2.5c-3.1,2.3-4.9,6-4.9,9.9c0,0.3,0,0.6,0,0.9h22.6 c-0.5,5.7-5.5,9.9-11.1,9.4c-2.5-0.2-4.8-1.3-6.5-3.1h-2.5c4,5.5,11.8,6.6,17.2,2.6c3.1-2.3,5-6,5-9.9c0-0.3,0-0.7,0-1h-22.6 c0.5-5.3,4.9-9.4,10.3-9.4c2.7,0,5.3,1.1,7.3,3L487.7,205.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSticky);
export default __webpack_public_path__ + "static/media/logo-sticky.94faaac2f75045abf21bd2486dd8cb28.svg";
export { ForwardRef as ReactComponent };